// extracted by mini-css-extract-plugin
export default {"customRow":"CardGroups_customRow__dluhs","image":"CardGroups_image__fGJlY","cards":"CardGroups_cards__0WSFs","heading":"CardGroups_heading__MvliG"};